import React, { useState } from "react";
import Spinner from "../components/Spinner";
import { Box, Button } from "@mui/material";
import config from "../Config";
import download from "downloadjs";

const pollActiveJob = (id: string) => {
  new Promise((resolve, reject) => {
    let lastStatusCode = "None";

    let timeout: NodeJS.Timeout;
    let task: NodeJS.Timer;

    timeout = setTimeout(() => {
      clearInterval(task);
      reject(`No 200 response. last status: ${lastStatusCode}`);
    }, 5000);

    task = setInterval(() => {
      fetch(`${config.youtube2mp3Url}/${id}`)
        .then((res) => {
          lastStatusCode = res.status.toString();
          if (res.status === 200) {
            clearTimeout(timeout);
            clearInterval(task);
            resolve(id); // ???
          }
        })
        .catch((e) => console.log(`Error shilst polling job ${e}`));
    }, 500);
  });
};

export const Youtube2Mp3 = () => {
  const [activeJob, setActiveJob] = useState<string | undefined>();

  function startConversion() {
    const commandBox: HTMLTextAreaElement = document.getElementById(
      "url"
    ) as HTMLTextAreaElement;

    commandBox.value = "";
    setActiveJob("unknown");
    fetch(`${config.hegbotUrl}/something`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({ url: commandBox.value }),
    })
      .then((result) => {
        if (result.status === 201) {
          return result.json();
        } else {
          throw new Error("Failed to submit job");
        }
      })
      .then((body) => {
        setActiveJob(body.jobId);
        return pollActiveJob(body.jobId);
      })
      .then((id) => {
        download(`${config.youtube2mp3Url}/${id}`);
      });
  }

  if (activeJob) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Spinner scale={0.5} />
        <h2>Loading...</h2>
      </Box>
    );
  } else {
    return (
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <h3>YouTube 2 MP3</h3>
        <Box>
          URL:
          <input
            id="url"
            type="text"
            data-testid="cmd-input"
            size={50}
            style={{ marginLeft: "10px" }}
          />
          <Button
            type="button"
            onClick={() => startConversion()}
            variant="outlined"
            size="medium"
            sx={{
              color: "white",
              border: "1px solid black",
              borderRadius: "12px",
              backgroundColor: "rgb(74, 74, 74)",
              height: "4em",
              textTransform: "none",
              margin: "2px",
              zIndex: 0,
              ml: "10px",
              "&:hover": {
                border: `2px solid white`,
                backgroundColor: "rgb(74, 74, 74)",
              },
            }}
          >
            CONVERT
          </Button>
        </Box>
      </Box>
    );
  }
};
